var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},[_c('div',{staticClass:"steps-flex flex align-cen"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"steps-flex-list flex align-cen",class:{current:_vm.active == item.steps}},[_c('div',{staticClass:"zent-steps-step"},[_vm._v(" "+_vm._s(item.steps)+". "+_vm._s(item.text)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }